import { type PartialPropsOf } from '@blaze-runtime/engine-domain';

import { type PropsMigration } from '../../../services/compat/migrations/layout-migration.models';

export const listV3Migration: PropsMigration = {
  mode: 'props',
  description: 'Migrate List element to v3 by migrating label color to label & icon colors',
  run: (props: PartialPropsOf<'list'>): void => {
    const listProps = props;

    if (listProps?.style?.general?.heading && !listProps?.content?.title?.iconColor) {
      const currentColor = listProps.style.general.heading.color1;
      listProps.content = {
        ...listProps.content,
        title: {
          ...listProps.content?.title,
          iconColor: { color1: currentColor },
        },
      };
    }
  },
};
